import type { ZodiacSign } from "@/features/advisors"

/** Western tropical zodiac cut-offs: a sign starts on `[month, day]` (1-based month). */
const ZODIAC_RANGES: { sign: ZodiacSign; from: [number, number] }[] = [
  { sign: "Capricorn", from: [12, 22] },
  { sign: "Sagittarius", from: [11, 22] },
  { sign: "Scorpio", from: [10, 23] },
  { sign: "Libra", from: [9, 23] },
  { sign: "Virgo", from: [8, 23] },
  { sign: "Leo", from: [7, 23] },
  { sign: "Cancer", from: [6, 21] },
  { sign: "Gemini", from: [5, 21] },
  { sign: "Taurus", from: [4, 20] },
  { sign: "Aries", from: [3, 21] },
  { sign: "Pisces", from: [2, 19] },
  { sign: "Aquarius", from: [1, 20] },
  // Jan 1–19 falls back to Capricorn (handled by the default below).
]

/** Resolve the zodiac sign from a `YYYY-MM-DD` birth date. Returns null on bad input. */
export function getZodiacSign(birthDate: string): ZodiacSign | null {
  const [, month, day] = birthDate.split("-").map(Number)
  if (!month || !day) return null

  const match = ZODIAC_RANGES.find(({ from: [m, d] }) => month > m || (month === m && day >= d))
  // Dates before Jan 20 wrap to Capricorn.
  return match?.sign ?? "Capricorn"
}

/** Backend contract value: lowercase slug, e.g. "aries". */
export function getZodiacSlug(birthDate: string): string | null {
  const sign = getZodiacSign(birthDate)
  return sign ? sign.toLowerCase() : null
}
